module.exports = __webpack_public_path__ + "static/media/stiwi.6d8b0e54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/stiwi.jpg
// module id = 624
// module chunks = 0